import { createPopper } from '@popperjs/core';
import throttle from 'lodash/throttle';

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    customListContainerStyle: {
      type: Object,
      default: () => {},
    },
    itemKeyMapper: {
      type: Function,
      default: (item, index) => index,
    },
    itemLabelMapper: {
      type: Function,
      default: (item) => item,
    },
    itemDisabledMapper: {
      type: Function,
      default: () => false,
    },
    itemSelectedMapper: {
      type: Function,
      default: () => false,
    },
    itemChildrenMapper: {
      type: Function,
      default: (item) => item?.children,
    },
    portalTarget: {
      type: String,
      default: null,
    },
    relativeTo: {
      type: [HTMLElement, Object, String],
      default: null,
    },
    zIndex: {
      type: [String, Number],
      default: '99999',
    },
    listMaxHeight: {
      type: String,
      default: null,
    },
    listStyle: {
      type: Object,
      default: () => {},
    },
    position: {
      type: String,
      default: 'bottom-start',
    },
    popperOptions: {
      type: Object,
      default: () => {},
    },
    calculatePosition: {
      type: Function,
      default: (list, relativeElement, component, { width }) => {
        // eslint-disable-next-line no-param-reassign
        list.style.minWidth = width;

        return createPopper(relativeElement, list, {
          placement: component.position,
          ...component.popperOptions,
        });
      },
    },
  },
  watch: {
    items: {
      immediate: true,
      handler() {
        this.emitItemsChangedEvent();
      },
    },
  },
  created() {
    // eslint-disable-next-line func-names
    this.throttledEmitScrollEvent = throttle(this.emitScrollEvent, 500);
  },
  methods: {
    emitItemClickedEvent(item, index) {
      this.$emit('item-clicked', item, index);
    },
    emitClickaway(e) {
      this.$emit('clickaway', e);
    },
    emitKeydownEvent(e) {
      this.$emit('keydown', e);
    },
    emitScrollEvent(e) {
      this.$emit('scroll', e);
    },
    emitItemsChangedEvent() {
      this.$emit('items-changed', this.items);
    },
  },
};
